import resolveCompound from './resolveCompound';

const resolveRTC = ({ rawVal }: RTCProps) => resolveCompound({ rawVal })?.value || '';

export default resolveRTC;
